import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useGetUserInfoQuery } from "../features/user/userApiSlice";
import { useGetUserShopsByBusinessTypeQuery } from "../features/shop/shopApiSlice";

export const useWholesalerShopsState = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);

  const [showshare, setShowshare] = useState(0);
  const [show, setShow] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const handleCloseshare = () => {
    setShowshare(0);
    setShow(1);
  };

  const handleClosemodal = () => {
    setShow(0);
  };

  const handleShowshare = () => {
    setShow(0);
    setShowshare(1);
  };

  // RTK Query calls
  const { data: shopsData, isLoading: shopsLoading } = useGetUserShopsByBusinessTypeQuery(
    { userid: name?._id, businessType: "wholesellerShop", page: currentPage, limit: itemsPerPage },
    { skip: !name?._id }
  );

  const { data: userInfoData } = useGetUserInfoQuery(name?._id, {
    skip: !name?._id,
  });

  useEffect(() => {
    const categoryName = shopsData?.data?.Shops?.[0]?.shopCategory?.name;
    if (categoryName) {
      localStorage.setItem("mycategory", categoryName);
    }
  }, [shopsData]);

  return {
    navigate,
    name,
    wholesalerShop: shopsData?.data?.Shops || [],
    isloading: shopsLoading,
    showshare,
    setShowshare,
    show,
    setShow,
    userimg: userInfoData?.data?.User?.imageUrl,
    handleCloseshare,
    handleClosemodal,
    handleShowshare,
    currentPage,
    setCurrentPage,
    totalPages: shopsData?.totalPages || 1,
  };
};
